/* ==========================================================================
   Shoppable UGC — reel-style video slider (Sitting Pretty)
   Requires Swiper 11 (loaded via CDN before this file).
   ========================================================================== */
(function () {
  'use strict';

  var VIDEO_SLIDE_INDEX = 0; // inner media order: [video, before, after]

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function initRoot(root) {
    if (!root || root.dataset.spUgcReady === 'true' || !window.Swiper) return;
    root.dataset.spUgcReady = 'true';

    var gridEl = root.querySelector('.sp-ugc__grid');
    var modal = root.querySelector('[data-sp-ugc-modal]');
    if (!gridEl || !modal) return;

    var panel = modal.querySelector('.sp-ugc-modal__panel');
    var reelEl = modal.querySelector('.sp-ugc-reel');
    var perViewDesktop = parseInt(root.getAttribute('data-per-view-desktop'), 10) || 4;

    var state = { soundOn: false };
    var reel = null;
    var controllers = [];
    var built = false;

    /* ---- Grid carousel ---- */
    new window.Swiper(gridEl, {
      slidesPerView: 1.667,
      spaceBetween: 12,
      watchOverflow: true,
      navigation: {
        prevEl: root.querySelector('.sp-ugc__arrow--prev'),
        nextEl: root.querySelector('.sp-ugc__arrow--next')
      },
      breakpoints: {
        750: { slidesPerView: 2.5, spaceBetween: 14 },
        1000: { slidesPerView: perViewDesktop, spaceBetween: 16 }
      }
    });

    /* ---- Open cards ---- */
    root.querySelectorAll('[data-ugc-open]').forEach(function (card) {
      var idx = parseInt(card.getAttribute('data-ugc-open'), 10) || 0;
      card.addEventListener('click', function () { open(idx); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(idx); }
      });
    });

    /* ---- Video helpers ---- */
    function isVideoView(c) { return c.media && c.media.activeIndex === VIDEO_SLIDE_INDEX; }

    function applyMute(c) {
      if (!c.video) return;
      c.video.muted = !state.soundOn;
      c.mediaEl.classList.toggle('is-muted', !state.soundOn);
    }

    function playVideo(c) {
      if (!c.video) return;
      applyMute(c);
      var p = c.video.play();
      if (p && p.catch) {
        p.catch(function () {
          // Autoplay with sound blocked — fall back to muted.
          c.video.muted = true;
          c.mediaEl.classList.add('is-muted');
          var p2 = c.video.play();
          if (p2 && p2.catch) p2.catch(function () {});
        });
      }
    }

    function pauseVideo(c, reset) {
      if (!c.video) return;
      c.video.pause();
      if (reset) { try { c.video.currentTime = 0; } catch (e) {} }
    }

    /* ---- Playback state driven by the active reel slide ---- */
    function syncPlayback() {
      if (!reel) return;
      controllers.forEach(function (c, i) {
        if (i !== reel.activeIndex) pauseVideo(c, true);
      });
      var c = controllers[reel.activeIndex];
      if (!c) return;
      if (isVideoView(c)) playVideo(c); else pauseVideo(c);
    }

    function onMediaChange(c) {
      var vid = isVideoView(c);
      c.mediaEl.classList.toggle('is-image', !vid);
      if (reel && controllers[reel.activeIndex] === c) {
        if (vid) playVideo(c); else pauseVideo(c);
      }
    }

    /* ---- Lazy-build the reel once the modal is visible (correct sizing) ---- */
    function build() {
      if (built) return;
      built = true;

      reel = new window.Swiper(reelEl, {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,
        rewind: true,
        speed: 350,
        keyboard: { enabled: false },
        on: {
          slideChange: function () {
            controllers.forEach(function (c, i) {
              if (reel && i !== reel.activeIndex) {
                pauseVideo(c, true);
                if (c.media) c.media.slideTo(VIDEO_SLIDE_INDEX, 0);
              }
            });
          },
          slideChangeTransitionEnd: syncPlayback
        }
      });

      modal.querySelectorAll('.sp-ugc-reel__slide').forEach(function (slide) {
        var mediaEl = slide.querySelector('.sp-ugc-media');
        var video = slide.querySelector('[data-ugc-video]');
        var c = { slide: slide, mediaEl: mediaEl, video: video, media: null };

        if (video) {
          video.loop = false;
          video.muted = true;
          video.addEventListener('ended', function () {
            if (!reel) return;
            if (controllers[reel.activeIndex] === c && isVideoView(c)) {
              if (controllers.length > 1) reel.slideNext();
              else { video.currentTime = 0; video.play().catch(function () {}); }
            }
          });
        }

        if (mediaEl) {
          c.media = new window.Swiper(mediaEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: { el: slide.querySelector('.sp-ugc-media__bullets'), clickable: true },
            navigation: {
              prevEl: slide.querySelector('.sp-ugc-media__ctrl--prev'),
              nextEl: slide.querySelector('.sp-ugc-media__ctrl--next')
            },
            on: { slideChange: function () { onMediaChange(c); } }
          });
        }

        controllers.push(c);
      });

      // Sound toggles (shared preference)
      modal.querySelectorAll('[data-ugc-sound]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.soundOn = !state.soundOn;
          controllers.forEach(applyMute);
        });
      });

      // See-more (reveal only when the text is actually clamped)
      modal.querySelectorAll('[data-ugc-more]').forEach(function (btn) {
        var text = btn.parentElement.querySelector('[data-ugc-clamp]');
        if (text && text.scrollHeight > text.clientHeight + 2) btn.hidden = false;
        btn.addEventListener('click', function () {
          var expanded = text.classList.toggle('is-expanded');
          btn.textContent = expanded ? 'See less' : 'See more';
        });
      });

      // Reel chevrons (wrap via rewind)
      var up = modal.querySelector('[data-ugc-reel-prev]');
      var down = modal.querySelector('[data-ugc-reel-next]');
      if (up) up.addEventListener('click', function () { reel.slidePrev(); });
      if (down) down.addEventListener('click', function () { reel.slideNext(); });

      // Add to cart
      modal.querySelectorAll('[data-ugc-atc]').forEach(function (btn) {
        btn.addEventListener('click', function () { addToCart(btn); });
      });

      // Mouse wheel drives the reel (reels-style), throttled + wraps
      var wheelLock = false;
      panel.addEventListener('wheel', function (e) {
        if (e.target.closest && e.target.closest('.is-expanded')) return; // let expanded review scroll
        e.preventDefault();
        if (wheelLock || Math.abs(e.deltaY) < 6) return;
        wheelLock = true;
        if (e.deltaY > 0) reel.slideNext(); else reel.slidePrev();
        setTimeout(function () { wheelLock = false; }, 520);
      }, { passive: false });
    }

    /* ---- Open / close ---- */
    function open(i) {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sp-ugc-lock');
      build();
      if (reel) { reel.update(); reel.slideTo(i, 0); }
      controllers.forEach(function (c) {
        if (c.media) c.media.slideTo(VIDEO_SLIDE_INDEX, 0);
        c.mediaEl.classList.remove('is-image');
        applyMute(c);
      });
      syncPlayback();
      if (panel) panel.focus();
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sp-ugc-lock');
      controllers.forEach(function (c) { pauseVideo(c, true); });
    }

    modal.querySelectorAll('[data-ugc-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); reel && reel.slideNext(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); reel && reel.slidePrev(); }
    });

    /* ---- Cart (mirrors the theme's Hue add-to-cart integration) ---- */
    function addToCart(btn) {
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      var fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', 1);
      fd.append('sections', 'cart,cart-count');

      fetch(cartRoot() + 'cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added';
          close();
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var cartLink = document.querySelector("a[href='/cart'], a[href$='/cart']");
          if (cartLink) cartLink.click();
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
        })
        .catch(function () {
          btn.textContent = 'Error';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
        });
    }
  }

  function bootAll() {
    document.querySelectorAll('[data-sp-ugc-root]').forEach(initRoot);
  }

  function whenSwiper(cb) {
    if (window.Swiper) return cb();
    var tries = 0;
    var timer = setInterval(function () {
      if (window.Swiper || tries++ > 120) {
        clearInterval(timer);
        if (window.Swiper) cb();
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { whenSwiper(bootAll); });
  } else {
    whenSwiper(bootAll);
  }

  // Theme editor: (re)initialise a section when it loads
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sp-ugc-root]');
    if (root) whenSwiper(function () { initRoot(root); });
  });
})();
